'use client';

import { UnstyledButton } from '@mantine/core';
import { Menu } from 'lucide-react';
import { useTheme } from '@contexts/ThemeContext';

type DashboardHeaderProps = {
  /** Show the drawer toggle — mobile/tablet only, and only while it is closed. */
  showMenuButton?: boolean;
  onMenuClick?: () => void;
};

/**
 * The shell's navigation toggle for mobile/tablet (drawer closed), floating at
 * the top left. Notifications, the trial badge and the update reload live in
 * the sidebar footer, under the user profile.
 */
export default function DashboardHeader({ showMenuButton = false, onMenuClick }: DashboardHeaderProps) {
  const { colors: themeColors } = useTheme();

  return (
    <>
      {showMenuButton && (
        <UnstyledButton
          type="button"
          onClick={onMenuClick}
          aria-label="Open navigation menu"
          className="flex items-center justify-center rounded-lg transition-transform active:scale-95"
          style={{
            position: 'fixed',
            top: 12,
            left: 12,
            // Below the AppShell navigation drawer (z-100), which covers it once open.
            zIndex: 60,
            width: 36,
            height: 36,
            backgroundColor: themeColors.card,
            color: themeColors.text,
            border: `1px solid ${themeColors.border}`,
          }}
        >
          <Menu size={18} strokeWidth={1.5} />
        </UnstyledButton>
      )}
    </>
  );
}
